import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  dataAttrs?: Record<string, string | number>;
  className?: string;
  innerClassName?: string;
  footerClassName?: string;
};

export const Presentation: FunctionComponent<Props> = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  dataAttrs,
  className,
  innerClassName,
  footerClassName
}) => {
  return (
    <>
      <div className={classnames('common__modal', className, { active: isOpen })} {...dataAttrs}>
        <div className="common__modal__wrapper">
          <h3 className="common__modal__title">
            <div onClick={onClose} className="mask">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M0.735395 12L0 11.2646L5.26461 6L0 0.735394L0.735395 0L6 5.26461L11.2646 0L12 0.735394L6.7354 6L12 11.2646L11.2646 12L6 6.73539L0.735395 12Z" fill="#19190F"/>
              </svg>
            </div>
            <p className="title">{title}</p>
          </h3>

          <div className={classnames('common__modal__inner', innerClassName)}>
            {children}
          </div>

          {footer && (
            <div className={classnames('common__modal__submit', footerClassName)}>
              {footer}
            </div>
          )}
        </div>
      </div>
      <div onClick={onClose} className={classnames('common__modal--bg', { active: isOpen })}></div>
    </>
  );
};
